/**
 * Public paths that may be shared as plain URLs — `school.kalqy.in/contact-sales`
 * — although the app routes on the hash. On load, a known plain path is
 * rewritten to its hash route in place (no reload, no extra history entry).
 *
 * ⚠️ AN ALLOW-LIST, NOT "ANY PATH". Rewriting every unknown path would turn a
 * mistyped URL into some screen; only the addresses the product publishes are
 * honoured.
 */
export const PUBLIC_PATHS: readonly string[] = ['contact-sales']

export function hashForPath(pathname: string, hash: string): string | null {
  if (hash && hash !== '#' && hash !== '#/') return null
  const path = pathname.replace(/^\/+|\/+$/g, '')
  return PUBLIC_PATHS.includes(path) ? `#/${path}` : null
}

export function rewritePublicPath(loc: Location = window.location, hist: History = window.history): void {
  const target = hashForPath(loc.pathname, loc.hash)
  if (target) hist.replaceState(hist.state, '', `/${loc.search}${target}`)
}
